<template>
    <div align="center">
        <el-row class="title">
            <label style="font-size: 40px; font-weight: bold">{{this.$t("myPage.title")}}</label>
        </el-row>

        <div class="listMenu">
            <el-row style="background: rgba(178, 205, 228, 0.7); text-align: left; padding-bottom: 4px; padding-top: 5.5px">
                <label style="font-size: 20px; font-weight: bold; padding-left: 15px">{{this.$t("myPage.title")}}</label>
            </el-row>

            <el-row class="rowMyPage">
                <el-button class="btnMyPage" @click="bookingConfirm">{{this.$t("myPage.list.confirmBooking")}}
                </el-button>
            </el-row>
            <el-row class="rowMyPage">
                <el-button class="btnMyPage" @click="oldBookingConfirm">{{this.$t("myPage.list.confirmOldBooking")}}
                </el-button>
            </el-row>
            <el-row class="rowMyPage">
                <el-button class="btnMyPage" @click="changeInformation">{{this.$t("myPage.list.changeInfo")}}
                </el-button>
            </el-row>
            <el-row class="rowMyPage">
                <el-button class="btnMyPage" @click="changeEmail">{{this.$t("myPage.list.changeEmail")}}</el-button>
            </el-row>
            <el-row class="rowMyPage">
                <el-button class="btnMyPage" @click="changePassword">{{this.$t("myPage.list.changePassword")}}
                </el-button>
            </el-row>
            <el-row class="rowMyPage">
                <el-button class="btnMyPage" @click="viewSystemRules">{{this.$t("myPage.list.termsOfService")}}
                </el-button>
            </el-row>
        </div>

    </div>
</template>

<script>
    export default {
        name: "MyPage",
        data() {
            return {}
        },
        methods: {
            bookingConfirm() {
                this.$router.push({path: "/myPage/bookingConfirm"})
            },
            oldBookingConfirm() {
                this.$router.push({path: "/myPage/oldBookingConfirm"})
            },
            changePassword() {
                this.$router.push({path: "/end_user/changePassword"})
            },

            changeInformation() {
                this.$router.push({path: "/end_user/changeInformation"})
            },

            changeEmail() {
                this.$router.push({path: "/end_user/changeEmail"})
            },

            viewSystemRules() {
                this.$router.push({path: "/end_user/viewSystemRules"})
            }
        }
    }
</script>

<style scoped>
    .rowMyPage {
        border-bottom: inset;
        border-left: solid;
        border-left-color: #faf9ff;
        border-left-width: 1px;
        border-right: solid;
        border-right-color: #faf9ff;
        border-right-width: 1px;
    }

    .btnMyPage {
        padding-left: 25px;
        width: 100%;
        text-align: left;
        height: 55px;
        border-radius: 0;
        border: none
    }

    .listMenu {
        margin-top: 50px;
        width: 40%
    }

    .title {
        margin-top: 50px;
    }

    @media (max-width: 768px) {
        .listMenu {
            margin-top: 30px;
            width: 100%;
        }

        .title {
            margin-top: 30px;
        }

        .btnMyPage {
            height: 50px;
        }
    }
    
    @media (max-height: 568px) {
        .title {
            margin-top: 0px;
        }

        .listMenu {
            margin-top: 15px;
        }
    }
</style>